import { useMediaQuery } from "@mui/material";
import useBreakPoint from "../../../hooks/useBreakPoint";

export const useLayout = () => {
  const breakpointsObj = useBreakPoint();
  const layoutQuery = breakpointsObj.theme.breakpoints.down("lg");
  const isLayout = useMediaQuery(layoutQuery);
  return { ...breakpointsObj, layoutQuery, isLayout };
};
